/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { I18nService } from '@dm/core';
import { UNPLACEHOLDER } from 'app/common/constants';

import { CurSupplyModeTypeE, PowerModelTypeE } from './detail.const';
import { PortIPModeE } from './detail.enum';
import { SecurityType } from './type';

/**
 * 所有租户
 */
export const AllVstoreId = '-1';

/**
 * 系统租户
 */
export const SystemVstoreId = '0';

@Injectable({
    providedIn: 'root',
})
export class DetailI18nService {
    ESN = this.i18n.get('common.device_ESN_label');

    /** common */
    operationLab = this.i18n.get('common.operation_button');
    actionBtn = this.i18n.get('common.operation_button');
    modifyBtn = this.i18n.get('common.modify_button');
    closeBtn = this.i18n.get('common.close_button');
    modifyPortRoleMsg = this.i18n.get('system.FCPort_task_modify_portRole_comfirm_msg');
    modifyPortProtocolMsg = this.i18n.get('system.FCPort_task_modify_portProtocol_comfirm_msg');
    modifyPortMsg = this.i18n.get('system.FCPort_task_modify_portRole_comfirm_msg');
    protocolTypeLab = this.i18n.get('system.FCPort_task_modify_protocolType_lab');
    fcSCSI = this.i18n.get('system.FCPort_task_modify_protocolType_SCSI_value');
    fcNVME = this.i18n.get('system.FCPort_task_modify_protocolType_NVMe_value');
    serviceMode = this.i18n.get('system.hardware_term_serviceMode_lab');
    healthLabel = this.i18n.get('system.healthStatus_column');
    runningLabel = this.i18n.get('system.runningStatus_column');
    // 术语变更 riser-->carrier-->box
    carrierModel = this.i18n.get('common.type_column');
    locationLabel = this.i18n.get('system.location_column');
    elabelLabel = this.i18n.get('system.hardware_term_Elabel');
    modelLabel = this.i18n.get('system.hardware_term_diskMode_label');
    manufacturerLabel = this.i18n.get('system.hardware_term_Manufacturer_label');
    productionDateLabel = this.i18n.get('system.hardware_term_productDate');
    controllerLabel = this.i18n.get('system.hardware_term_ownController_lab');
    versionLabel = this.i18n.get('system.device_version_label');
    bomLabel = this.i18n.get('system.common_term_electricItem_label');
    temperatureLabel = this.i18n.get('system.hardware_term_diskTemperature_label');
    firmwareVersionLabel = this.i18n.get('system.hardware_term_FirmwareVer_label');
    bmcIpLabel = this.i18n.get('system.hardware_term_BMCIP_col');
    slotId = this.i18n.get('system.hardware_term_slotNum_col');
    frontFan = this.i18n.get('system.hardware_term_frontRotor_tab');
    rearFan = this.i18n.get('system.hardware_term_backRotor_tab');
    serialNumber = this.i18n.get('common.device_serialNumber_label');
    comma = this.i18n.get('common.comma_label');
    confirmBtn = this.i18n.get('common.confirm_button');
    cancelBtn = this.i18n.get('common.cancel_button');
    portType = this.i18n.get('common.portType_label');
    summaryLabel = this.i18n.get('common.summary_information');
    snsdBtn = this.i18n.get('system.network_roce_view_SNSD_column');
    ElabelTip = this.i18n.get('system.hardware_term_Elabel_tip');
    /**
     * 启用SNSD（Storage Network Smart Discovery）后，主机会感知到RoCE端口下所有逻辑端口的状态变化，
     * 帮助主机根据逻辑端口状态去判断是否自动建立或断开连接。
     */
    SNSDTip = this.i18n.get('system.network_roce_task_SNSD_tip');

    // 型号
    diskMode = this.i18n.get('system.hardware_term_diskMode_label');

    diskModeType = {
        0: this.i18n.get('system.hardware_term_diskMode_SAS_value'),
        1: this.i18n.get('system.hardware_term_diskMode_FC_value'),
        5: this.i18n.get('system.hardware_term_diskMode_NVMe_value'),
        6: this.i18n.get('system.hardware_term_diskMode_smartSAS_value'),
        7: this.i18n.get('system.hardware_term_diskMode_smartNVMe_value'),
    };

    switch = {
        on: this.i18n.get('common.service_enable_value'),
        off: this.i18n.get('common.service_disable_value'),
    };

    snsdSwitch = {
        on: this.i18n.get('common.enabled_switch_column'),
        off: this.i18n.get('common.disabled_switch_column'),
    };

    bool = {
        yes: this.i18n.get('common.term_yes_label'),
        no: this.i18n.get('common.term_No_label'),
    };

    mo = {
        expboard: this.i18n.get('system.hardware_term_expansionBoard_label'),
        controller: this.i18n.get('system.hardware_term_controller_tab'),
        power: this.i18n.get('system.hardware_term_powerModule_tab'),
        fan: this.i18n.get('system.hardware_term_FanModule_tab'),
        fanModules: this.i18n.get('system.hardware_term_FanModules_tab'),
        bbuModules: this.i18n.get('system.EnumDefine_MOTYPE_BACKUP_POWER'),
        fcPort: this.i18n.get('system.device_term_fcPort_label_label'),
    };

    /** enclosure */
    powerManageBtnBisabledTip = this.i18n.get('system.hardware_term_PowerManage_err_tip');
    locateMenu = this.i18n.get('system.device_term_locateEnclosure');
    unlocateMenu = this.i18n.get('system.hardware_term_cancelLocateEnclosure');
    locateSucceed = this.i18n.get('system.enclosure_locate_succeed_msg');
    unlocateSucceed = this.i18n.get('system.enclosure_unlocate_succeed_msg');
    EnclosureLogicTypeE = {
        expansion: this.i18n.get('common.diskEnclousre_lab'),
        control: this.i18n.get('common.controllerEnclousre_lab'),
        dataSwitch: this.i18n.get('system.EnumDefine_ENCLOSURE_TYPE_E_DSW'),
    };
    EnclosureModelE = {
        disk_4U_12gb_SAS_x75_3dot5: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_EXPSAS4U_75_12G'),
        disk_2U_SAS_x25_2dot5_65: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_SAS_2U_25'),
        disk_2U_SAS_x25_2dot5_67: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_SAS_2U_25'),
        disk_4U_SAS_x24_3dot5: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_SAS_4U_24'),
        disk_4U_SAS_x24_3dot5_66: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_SAS_4U_24'),
        ctrl_4U_x4: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_4U'),
        diskCtrl_2U_x2_SAS_x25_2dot5_113: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_DOUBLE_SAS_2U_25'),
        diskCtrl_2U_x2_SAS_x12_3dot5_114: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_DOUBLE_SAS_2U_12'),
        diskCtrl_2U_x2_NVMe_x36: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_DOUBLE_NVMe_2U_36'),
        diskCtrl_2U_x2_SAS_x25_2dot5_116: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_DOUBLE_SAS_2U_25'),
        diskCtrl_2U_x2_SAS_x12_3dot5_117: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_DOUBLE_SAS_2U_12'),
        disk_2U_IP_SAS_x25_2dot5_118: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_IP_SAS_2U_25'),
        disk_2U_IP_SAS_x12_3dot5: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_IP_SAS_2U_12'),
        disk_2U_IP_NVMe_x36: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_IP_NVMe_2U_36'),
        diskCtrl_2U_x2_NVMe_x25: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_DOUBLE_NVMe_2U_25'),
        diskCtrl_2U_x2_SAS_x25_2dot5_130: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_DOUBLE_SAS_2U_25'),
        diskCtrl_2U_x2_SAS_x12_3dot5_131: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_DOUBLE_SAS_2U_12'),
        diskCtrl_4U_x2_x10_3dot5_132: this.i18n.get('compute.system_device_controllerEnclosure_label'),
        diskCtrl_4U_x2_x12_2dot5_133: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_4U_12'),
        diskCtrl_4U_x2_x10_2dot5_135: this.i18n.get('compute.EnumDefine_ENCLOSURE_MODEL_E_CTRL_DOUBLE_4U_10_25'),
        diskCtrl_8U_x2_x64_2dot5_137: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_DOUBLE_NVMe_CONTROLLER_8U_64'),
        diskCtrl_2U_x2_x36_4card_139: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_DOUBLE_NVMe_CONTROLLER_2U_36'),
        diskCtrl_2U_x2_x36_6card_140: this.i18n.get('common.EnumDefine_ENCLOSURE_MODEL_E_CTRL_DOUBLE_NVMe_CONTROLLER_2U_36'),
    };

    powerSetLabel = this.i18n.get('system.hardware_term_PowerSettings_lab');
    workTypeLabel = this.i18n.get('system.hardware_term_PowerMode_lab');
    mainPowerLabel = this.i18n.get('system.hardware_term_PowerMode_primaryPower_value');
    modifyPowerLabel = this.i18n.get('system.hardware_term_PowerManage_btn');
    powerModelLabel = this.i18n.get('system.hardware_term_PowerSettings_lab');
    powerkModeType = {
        [PowerModelTypeE.MAIN]: this.i18n.get('system.hardware_term_PowerMode_primaryPower_value'),
        [PowerModelTypeE.STANDBY]: this.i18n.get('system.hardware_term_PowerMode_standbyPower_value'),
        [PowerModelTypeE.EQUALIZED]: this.i18n.get('system.hardware_term_PowerMode_loadBalance_value'),
    };
    curSupplyModeType = {
        [CurSupplyModeTypeE.MAIN_OR_STANDBY]: this.i18n.get('system.hardware_term_PowerMode_energySave_value'),
        [CurSupplyModeTypeE.EQUALIZED]: this.i18n.get('system.hardware_term_PowerMode_loadBalance_value'),
    };

    /** controller */
    cacheSizeLabel = this.i18n.get('system.harware_term_cacheSize_label');
    CPU = this.i18n.get('system.hardware_term_CPUs_col');
    hardwareCPU = this.i18n.get('system.hardware_term_CPU');
    roleLabel = this.i18n.get('common.role_label');

    /** disk */
    diskTypeLabel = this.i18n.get('system.type_column');
    diskLogicTypeLabel = this.i18n.get('system.role_label');
    capacityLabel = this.i18n.get('system.capacity_column');
    manuCapacity = this.i18n.get('system.hardware_term_ManufaturCap_column');
    poolBelongToLabel = this.i18n.get('monitor.charts_term_objectType_STORAGEPOOL');
    diskDomain = this.i18n.get('monitor.charts_term_objectType_DISKPOOL');
    bandWidthLabel = this.i18n.get('common.bandwidth2_label');
    rpmLabel = this.i18n.get('system.hardware_term_diskSpeed_withRPM_label');
    runTimeLabel = this.i18n.get('system.hardware_term_diskRunTime_label');
    wearDegreeLabel = this.i18n.get('system.hardware_term_abrasion_label');
    diskRemainLifeLabel = this.i18n.get('system.device_term_LifeSpanForMonth_label');
    multipathLabel = this.i18n.get('system.hardware_term_Multipath_label');
    encryptionTypeLabel = this.i18n.get('system.hardware_term_encryType_label');
    autoLockLabel = this.i18n.get('system.hardware_term_enableAK_label');
    cofferLabel = this.i18n.get('system.hardware_term_IfCofferDisk_label');
    akExpirationDateInvaLabel = this.i18n.get('system.hardware_term_AKexpirationDate_lab');
    eraseProgess = this.i18n.get('system.systemSetting_setEncryptDrive_term_dataEraseProgess_label');
    diskEncryptionTypeE = {
        normal: this.i18n.get('system.hardware_term_encryType_commonDisk_value'),
        encrypted: this.i18n.get('system.hardware_term_encryType_encryptedDisk_value'),
    };

    diskLogicTypeE = {
        free: this.i18n.get('common.EnumDefine_DISK_LOGIC_TYPE_E_FREE'),
        member: this.i18n.get('common.EnumDefine_DISK_LOGIC_TYPE_E_MEMBER'),
        spare: this.i18n.get('common.EnumDefine_DISK_LOGIC_TYPE_E_SPARE'),
        cache: this.i18n.get('common.EnumDefine_DISK_LOGIC_TYPE_E_CACHE'),
    };

    abrationLevel = {
        low: this.i18n.get('system.hardware_term_lowAbrasion_value'),
        middle: this.i18n.get('system.hardware_term_mediumAbrasion_value'),
        high: this.i18n.get('system.hardware_term_highAbrasion_value'),
    };

    dataPathStatusE = {
        normal: this.i18n.get('common.EnumDefine_STATUS_E_NORMAL'),
        degraded: this.i18n.get('common.EnumDefine_HEALTH_STATUS_degraded'),
    };

    /** port common */
    workModeLabel = this.i18n.get('system.device_controlEnsoure_view_Ethport_workMode_lab');
    workRateLabel = this.i18n.get('system.hardware_term_runSpeed_label');
    maxWorkRateLabel = this.i18n.get('system.hardware_term_maxRunSpeed_label');
    portStatusLabel = this.i18n.get('system.device_term_portStatus_label');
    initiatorCountLabel = this.i18n.get('system.common_term_hostInitiatorNum_label');
    autoAdaptionValue = this.i18n.get('system.hardware_term_port_value_autoAdaption');
    portLogicTypeLabel = this.i18n.get('system.hardware_term_portLogicType_cloumn');
    portGroupLabel = this.i18n.get('system.hardware_term_owningPortGroup_tab');
    portGroupsLabel = this.i18n.get('system.hardware_term_owningPortGroups_tab');
    basicInfoLab = this.i18n.get('common.basicInfo_title');
    memoryLab = this.i18n.get('system.hardware_term_memory_col');
    vStoreName = this.i18n.get('common.vstoreName_lab');
    vStoreLab = this.i18n.get('common.owningVstore_lab');
    vStoreNameLab = this.i18n.get('vstore_name_lab');
    vStoreIdLab = this.i18n.get('vstore_id_lab');
    // 归属交换机
    belongSwitchLab = this.i18n.get('system.hardware_term_SOSwitchPorts_belongSwitch_col');
    // 描述
    description = this.i18n.get('common.description_column');

    PortLogicTypeE = {
        bussiness: this.i18n.get('system.EnumDefine_PORT_LOGIC_TYPE_E_SERVICE'),
        expansion: this.i18n.get('system.EnumDefine_PORT_LOGIC_TYPE_E_EXP'),
        management: this.i18n.get('system.EnumDefine_PORT_LOGIC_TYPE_E_MNGT'),
        maintenance: this.i18n.get('system.EnumDefine_PORT_LOGIC_TYPE_E_MAINTENANCE'),
        scaleOut: this.i18n.get('system.EnumDefine_PORT_LOGIC_TYPE_E_IP_SCALE_OUT'),
        frontEndContainer: this.i18n.get('system.EnumDefine_PORT_LOGIC_TYPE_E_CONTAINER_FRONT'),
        backEndContainer: this.i18n.get('system.EnumDefine_PORT_LOGIC_TYPE_E_CONTAINER_BACK'),
        switchPort: this.i18n.get('system.EnumDefine_PORT_LOGIC_TYPE_E_SWITCH'),
    };

    /** initiator */
    initiatorsLabel = this.i18n.get('host.host_view_initiator_title');
    initiatorsNumberLabel = this.i18n.get('system.common_term_hostInitiatorNum_label');
    wwpnLabel = this.i18n.get('common.WWPN_lab');
    iqnLabel = this.i18n.get('common.IQN_label');
    aliasLabel = this.i18n.get('common.alias_lab');
    isFreeLabel = this.i18n.get('system.hardware_term_freeOrNot_column');
    statusLabel = this.i18n.get('common.status_column');
    immediateDataLabel = this.i18n.get('protection.configuration_remoteDevice_task_addRemoteDevice_immediateData_lab');
    enable = this.i18n.get('common.enable_label');

    /** interface module */
    powerOnMenu = this.i18n.get('system.hardware_term_powerOn');
    powerOffMenu = this.i18n.get('system.hardware_term_powerOff');
    powerOffIntfModuleTitle = this.i18n.get('system.hardware_term_poweroffInter');
    powerOnSucceed = this.i18n.get('system.interface_module_power_on_succeed_msg');
    powerOffSucceed = this.i18n.get('system.interface_module_power_off_succeed_msg');

    /** eth */
    trafficLab = this.i18n.get('monitor.monitor_reporter_TrafficStatistics_label');
    macLabel = this.i18n.get('system.hardware_term_Macaddress_label');
    bondNameLabel = this.i18n.get('system.hardware_term_bondingName');
    iscsiTargetLabel = this.i18n.get('system.hardware_term_iscsitarget_label');
    bondPortLabel = this.i18n.get('system.hardware_term_bindv');
    lifLabel = this.i18n.get('common.logicalPort_label');
    lifLabels = this.i18n.get('common.LogicalPorts');
    logicalPortsLabel = this.i18n.get('common.LogicalPorts');
    memberPortsLabel = this.i18n.get('host.portGroup_view_memberPort_title');
    nameLabel = this.i18n.get('system.name_column');
    ipLabel = this.i18n.get('system.hardware_term_IP_column');
    maskLabel = this.i18n.get('system.dataProtection_dirReplication_term_subnetMaskPrefix_label');
    mtuLabel = this.i18n.get('system.device_controlEnsoure_view_Ethport_maxTransUnit');
    trustLabel = this.i18n.get('system.network_roce_view_trustMode_col');
    ipv4Label = this.i18n.get('common.term_IPV4address');
    ipv4MaskLabel = this.i18n.get('common.term_subNetworkMask');
    ipv4GatewayLabel = this.i18n.get('common.ipv4Gateway_label');
    ipv6Label = this.i18n.get('common.term_IPV6address');
    ipv6PrefixLabel = this.i18n.get('common.preix_label');
    ipv6GatewayLabel = this.i18n.get('common.ipv6Gateway_label');
    ipModeLabel = this.i18n.get('system.network_task_IPMode_col');
    macFormatErr = this.i18n.get('system.device_term_para_format_MACexample_validation');
    v4MaskErr = this.i18n.get('system.device_term_para_format_subnetMaskexample_validation');
    v6MaskErr = this.i18n.get('system.device_term_para_format_IPV6PrefixRange_validation');
    notMatchErr = this.i18n.get('system.device_term_para_format_IPsubnetMask_NoMatch_validation');
    modifyEthMtuWarnMsg = this.i18n.get('system.hardware_modifyiSCSIHostPort_MTU_task_confirmation_message');
    modifyBondMtuWarnMsg = this.i18n.get('system.systemSetting_network_task_changeBondPort_info_message');
    deleteLifPromptTitle = this.i18n.get('system.systemSetting_network_task_deleteLIF_button');
    deleteLifPromptContent = this.i18n.get('system.systemSetting_network_task_deleteRoute_info_new_message');
    modifyLifPromptTitle = this.i18n.get('system.systemSetting_network_task_modifyLogicalPort_tittle');
    modifyLifPromptContent = this.i18n.get('system.systemSetting_network_task_modifyLif_info_message');
    vlanPort = this.i18n.get('system.hardware_term_VLAN_tab');
    vlanPorts = this.i18n.get('system.hardware_term_VLANs_tab');
    modifyVstoreTip = this.i18n.get('system.network_eth_modifyLogicalPort_err_tip');
    /**
     * 启用SNSD
     */
    enablegSNSDTitle = this.i18n.get('system.network_roce_task_enablegSNSD_title');
    /**
     * 禁用SNSD
     */
    disablegSNSDTitle = this.i18n.get('system.network_roce_task_disablegSNSD_title');
    /**
     * 您将要执行启用ROCE端口SNSD功能的操作。<br/>启用SNSD功能开关后，存储设备会向交换机发出LLDP报文，
     * 若交换机不支持，可能会有错误报文统计导致的告警。<br/>建议：执行此操作前，请确保交换机支持此特性。
     */
    enableSNSD = this.i18n.get('system.network_eth_enableSNSD_confirm_msg');
    /**
     * 您将要执行禁用ROCE端口SNSD功能的操作。<br/>禁用SNSD功能开关后，将不支持自动建链和故障快速感知功能。<br/>建议：执行此操作之前，请确认已了解此操作的风险 。
     */
    disableSNSD = this.i18n.get('system.network_eth_disableSNSD_confirm_msg');
    ethWorkModeE = {
        invalid: UNPLACEHOLDER,
        autoAdapt_10GE: this.i18n.get('system.hardware_term_portmodel_autoNegotiationEth_10G_lab'),
        autoAdapt_25GE: this.i18n.get('system.hardware_term_portmodel_autoNegotiationEth_25G_lab'),
        baseFEC_10GE: this.i18n.get('system.hardware_term_portmodel_BASEFECEth_10G_lab'),
        noFEC_10GE: this.i18n.get('system.hardware_term_portmodel_NOFECEth_10G_lab'),
        noFEC_25GE: this.i18n.get('system.hardware_term_portmodel_NOFECEth_25G_lab'),
        baseFEC_25GE: this.i18n.get('system.hardware_term_portmodel_BASEFECEth_25G_lab'),
        rsFEC_25GE: this.i18n.get('system.hardware_term_portmodel_RSFECEth_25G_lab'),
        autoAdapt_40GE: this.i18n.get('system.hardware_term_portmodel_autoNegotiationEth_40G_lab'),
        autoAdapt_100GE: this.i18n.get('system.hardware_term_portmodel_autoNegotiationEth_100G_lab'),
        baseFEC_40GE: this.i18n.get('system.hardware_term_portmodel_BASEFECEth_40G_lab'),
        noFEC_40GE: this.i18n.get('system.hardware_term_portmodel_NOFECEth_40G_lab'),
        noFEC_100GE: this.i18n.get('system.hardware_term_portmodel_NOFECEth_100G_lab'),
        rsFEC_100GE: this.i18n.get('system.hardware_term_portmodel_RSFECEth_100G_lab'),
        autoNeg: this.i18n.get('system.hardware_term_portmodel_antoConsult_lab'),
        rsFEC_200GE: this.i18n.get('system.hardware_term_portmodel_RSFECEth_200G_lab'),
        llrsFEC_200GE: this.i18n.get('system.hardware_term_portmodel_LLRSFECEth_200G_lab'),
        autoSensing_200GE: this.i18n.get('system.hardware_term_portmodel_autoNegotiationEth_200G_lab'),
    };

    /** FC */
    configSpeedLabel = this.i18n.get('system.hardware_term_configSpeed_label');
    fcWorkModeE = {
        fabric: this.i18n.get('system.EnumDefine_FC_PORT_MODE_E_FABRIC'),
        fc_al: this.i18n.get('system.EnumDefine_FC_PORT_MODE_E_LOOP'),
        p2p: this.i18n.get('system.EnumDefine_FC_PORT_MODE_E_POINT2POINT'),
        auto: this.i18n.get('system.EnumDefine_FC_PORT_MODE_E_AUTO'),
    };
    fcProtocolOpt = {
        1: this.i18n.get('system.FCPort_task_modify_protocolType_SCSI_value'),
        2: this.i18n.get('system.FCPort_task_modify_protocolType_NVMe_value'),
    };

    /** 立即数 */
    fastWriteEnableOpt = {
        0: this.i18n.get('common.disabled_switch_column'),
        1: this.i18n.get('common.enabled_switch_column'),
    };

    /** fan */
    runLevelLabel = this.i18n.get('system.hardware_term_runLevel');
    fanRunLevelE = {
        low: this.i18n.get('common.EnumDefine_FAN_LEVEL_E_LOW'),
        normal: this.i18n.get('common.EnumDefine_FAN_LEVEL_E_NORMAL'),
        high: this.i18n.get('common.EnumDefine_FAN_LEVEL_E_HIGH'),
    };

    /** power */
    powerTypeLabel = this.i18n.get('system.type_column');
    powerTypeE = {
        dc: this.i18n.get('common.EnumDefine_POWER_TYPE_E_DC'),
        ac: this.i18n.get('common.EnumDefine_POWER_TYPE_E_AC'),
    };

    /** bbu */
    bbuRemnantLifeLabel = this.i18n.get('system.hardware_term_remainLifeTime_label');
    dischargeTimesLabel = this.i18n.get('system.hardware_term_chargeTimes');

    /** expansion board */
    expBoardModelE = {
        sas: 'SAS',
        fc: 'FC',
    };

    // 需要伪装的接口卡映射表
    intfModulePortMap = {
        583: this.i18n.get('system.device_term_SASPort_left_title'),
    };

    expboardFanTitle = this.i18n.get('{0}/{1}', [this.mo.expboard, this.mo.fan]);
    controllerFanTitle = this.i18n.get('system.hardware_term_controllerAndFanModules_tittle');
    controllerBbuTitle = this.i18n.get('system.hardware_term_controllerAndBBU_title');
    powerFanTitle = this.i18n.get('system.hardware_term_powerModuleAndFanModules_tittle');
    ipErr = this.i18n.get('system.device_term_para_format_ipAddress_validation');
    formatIpv4Err = this.i18n.get('system.device_term_para_format_ipv4Address_validation');
    maskErr = this.i18n.get('system.device_term_para_format_subNetAndPrefix_validation');
    sasPortTitle = this.i18n.get('system.device_term_SASPort_left_title');

    // 绑定端口
    bondPort = this.i18n.get('compute.service_network_BindPorts_lab');
    bondMode = this.i18n.get('compute.service_network_BindMode_lab');
    bondModeHighRisk = this.i18n.get('compute.systemSetting_network_task_changeBondPort_info_message');

    // 切换安全类型
    changeSecruityTypeBtn = this.i18n.get('system.hardware_modify_interfaceModul_changeSecurityType_btn');
    // 安全类型
    securityTypeLab = this.i18n.get('system.hardware_modify_interfaceModul_SecurityType_lab');
    // 切换安全类型高危提示
    changeSecruityMsg = this.i18n.get('system.hardware_modify_interfaceModulSecurityType_confirm_msg');
    // IPsec
    IPsecLab = this.i18n.get('system.hardware_modify_interfaceModul_SecurityType_IPsec_value');
    // 无
    noneLab = this.i18n.get('common.term_confirm_none');
    securityTypeHelpContent = this.i18n.get('system.hardware_modify_interfaceModul_SecurityType_tip');

    securityTypeOptions = [
        {
            label: this.noneLab,
            value: SecurityType.None,
        },
        {
            label: this.IPsecLab,
            value: SecurityType.IPsec,
        },
    ];

    ipModeOptions = [
        {
            label: this.i18n.get('system.network_task_IPMode_static_value'),
            value: PortIPModeE.STATIC,
        },
        {
            label: this.i18n.get('system.network_task_IPMode_dynamic_value'),
            value: PortIPModeE.DYNAMIC,
        },
    ];

    //IP模式
    ipModes = {
        [PortIPModeE.STATIC]: this.i18n.get('system.network_task_IPMode_static_value'),
        [PortIPModeE.DYNAMIC]: this.i18n.get('system.network_task_IPMode_dynamic_value'),
    };

    constructor(
        private i18n: I18nService,
    ) { }

    modifyWinTitle = (name: string): string => this.i18n.get('system.device_term_modifyWarnTitle', [name]);
    controllerTitle = (location: string): string => this.i18n.get('system.controller_term_title', [location]);
    intfModuleTitle = (location: string): string => this.i18n.get('system.interfaceModule_term_title', [location]);
    bbuTitle = (location: string): string => this.i18n.get('system.BBU_term_title', [location]);
    serialTitle = (location: string): string => this.i18n.get('system.serialPort_term_title', [location]);
    fanTitle = (location: string): string => this.i18n.get('system.fan_term_title', [location]);
    powerTitle = (location: string): string => this.i18n.get('system.power_term_title', [location]);
    expBoardTitle = (location: string): string => this.i18n.get('system.expBoard_term_title', [location]);
    diskTitle = (location: string): string => this.i18n.get('system.device_controlEnsoure_view_disk_title', [location]);
    // 术语变更 riser-->carrier-->box
    carrierTitle = (location: string): string => this.i18n.get('system.hardware_term_riser_title', [location]);
    managementBoardTitle = (location: string): string => this.i18n.get('system.hardware_term_ManagementBoards_wintitle', [location]);
    computeNodeTitle = (location: string): string => this.i18n.get('system.hardware_term_computeNodes_wintitle', [location]);
    ethTitle = (location: string): string => this.i18n.get('system.device_controlEnsoure_view_Ethport_title', [location]);
    rdmaPortTitle = (location: string): string => this.i18n.get('system.device_controlEnsoure_view_RDMAport_title', [location]);
    roceTitle = (location: string): string => this.i18n.get('system.device_controlEnsoure_view_RoCEport_title', [location]);
    bondTitle = (name: string): string => this.i18n.get('system.hardware_term_bindv', [name]);
    lifTitle = (name: string): string => this.i18n.get('common.logicalPort_label', [name]);
    fanCtrlTitle = (location: string): string => this.i18n.get('system.device_controlEnsoure_view_coolingUnit_title', [location]);
    fcTitle = (location: string): string => this.i18n.get('system.device_controlEnsoure_view_FCport_title', [location]);
    sasTitle = (location: string): string => this.i18n.get('system.device_controlEnsoure_view_SASport_title', [location]);
    sasPortModel = (maxSpeed: number): string => this.i18n.get('system.device_controlEnsoure_term_model_SASport_4x', [maxSpeed]);
    enclosureTitle = (type: string, location: string): string =>
        this.i18n.get('system.hardware_term_enclousre_typeAndLocation', [type, location]);
    powerOffDanger = (location: string): string => this.i18n.get('system.hardware_task_poweroffInterfaceModule_confirm_msg', [location]);
    requiredErr = (label: string | string[]): string => this.i18n.get('common.null_validation', [label]);
    commonNameErr = (label: string[]): string => this.i18n.get('common.nameformat_validation', [label]);
    lengthErr = (min: number, max: number): string => this.i18n.get('common.length_msg', [min, max]);
    ipv4Err = (label: string): string => this.i18n.get('system.hardware_term_format_error', [label, '192.168.1.100']);
    ipv4MaskErr = (label: string): string => this.i18n.get('system.hardware_term_format_error', [label, '255.255.255.0']);
    ipv4GatewayErr = (label: string): string => this.i18n.get('system.hardware_term_format_error', [label, '172.16.0.1']);
    ipv6Err = (label: string): string => this.i18n.get('system.hardware_term_format_error', [label, this.i18n.get('common.ipv6_example')]);
    ipv6PrefixErr = (label: string): string => this.i18n.get('system.hardware_term_format_error', [label, '128']);
    ipv6GatewayErr = (label: string): string =>
        this.i18n.get('system.hardware_term_format_error', [label, this.i18n.get('common.ipv6_example')]);
    modifyServicePortMessage = (name: string): string => this.i18n.get('system.device_term_modifyServicePort', [name]);
    modifyManagePortMessage = (name: string): string => this.i18n.get('system.device_term_modifyManagePort', [name]);
    modifyMaintenancePortMessage = (name: string): string => this.i18n.get('rest.modifyMaintenancePort_msg', [name]);
    modifyBondPortMessage = (name: string): string => this.i18n.get('rest.modifyBondPort_msg', [name]);
    modifyFcPort = (name: string): string => this.i18n.get('rest.modifyFCPort_msg', [name]);
    addLifMessage = (lifName: string): string => this.i18n.get('system.device_term_addLIF', [lifName]);
    removeLifMessage = (lifName: string): string => this.i18n.get('system.device_term_deleteLIF', [lifName]);
    modifyLifMessage = (lifName: string): string => this.i18n.get('system.device_term_modifyLIF', [lifName]);
    modifyWarnTitle = (targetType: string): string => this.i18n.get('system.device_term_modifyWarnTitle', [targetType]);
    // 交换机端口标题
    switchPortTitle = (name: string): string => this.i18n.get('system.hardware_term_SOSwitch_switchport_title', [name]);
    // 交换机标题
    switchTitle = (name: string): string => this.i18n.get('system.hardware_term_SOSwitch_switch_title', [name]);
    modifyEthMacWarnMsg = (location: string): string =>
        this.i18n.get('system.hardware_modifyETH_phyMACAdd_task_confirmation_msg', [location]);
    modifyEthWorkModeWarnMsg = (location: string): string => this.i18n.get('system.hardware_term_portmodel_modify_msg', [location]);
    modifyEthRemoveIpWarnMsg = (location: string): string => (
        this.i18n.get('system.hardware_modifyiSCSIHostPort_cleanIP_task_confirmation_message', [location])
    );
    modifyEthIpWarnMsg = (location: string): string =>
        this.i18n.get('system.hardware_modifyiSCSIHostPort_task_confirmation_message', [location]);
    modifyManageIpWarnMsg = (location: string, ip: string, gateway: string): string =>
        this.i18n.get(
            'system.hardware_modifyManagePortPort_IP_task_confirmation_message',
            [location, ip, gateway],
        );
    modifyManageIpWarnOemMsg = (location: string, ip: string, gateway: string): string =>
        this.i18n.get(
            'system.hardware_modifyManagePortPort_IP_task_confirmation_oem_message',
            [location, ip, gateway],
        );
    modifyFcConfSpeedWarnMsg = (location: string): string =>
        this.i18n.get('system.hardware_modifyFCHostPort_task_confirmation_message', [location]);
    repeatErr = (label: string[]): string => this.i18n.get('common.allCanNotEquall_msg', [label]);
    rangeStr = (from: number, to: number): string => this.i18n.get('common.valueRange_label', [from, to]);
    // 接口模块服务模式
    serviceModeMap = (serviceMode: string): string => {
        switch (serviceMode) {
            case '1':
                return this.i18n.get('system.hardware_term_serviceMode_storage_value');
            case '2':
                return this.i18n.get('system.hardware_term_serviceMode_storage_value');
            case '3':
                return this.i18n.get('system.hardware_term_serviceMode_storage_value');
            case '4':
                return this.i18n.get('system.hardware_term_serviceMode_storage_value');
            case '5':
                return this.i18n.get('system.hardware_term_serviceMode_storage_value');
            case '6':
                return this.i18n.get('system.hardware_term_serviceMode_containerFront_value');
            case '7':
                return this.i18n.get('system.hardware_term_serviceMode_containerBack_value');
            case '8':
                return this.i18n.get('system.hardware_term_serviceMode_storage_value');
            case '9':
                return this.i18n.get('common.EnumDefine_LicenseFuncFeatureType_651');
            case '10':
                return this.i18n.get('system.hardware_term_serviceMode_cloudvxlanDToe_value');
            case '11':
                return this.i18n.get('system.hardware_term_serviceMode_containerFront_value');
            case '12':
                return this.i18n.get('system.hardware_term_serviceMode_containerBack_value');
            default:
                return UNPLACEHOLDER;
        }
    };
}
